module.exports = __webpack_public_path__ + "img/jiaban.825174f0.png";